Ext.define('WindowOperatorOwnRoleAddEdit', {
    extend: 'Ext.ux.window.WindowExd',
    title: Lang.role_wlasne.capitalise(),
    width: 950,
    height: 785,
    closable: false,
    collapsible: false,
    modal: true,
    resizable: false,
    scrollable: true,
    layout: 'fit',
    initComponent: function (config) {
        this.cid = Ext.id();
        let formpanel = {
            title: Lang.ogolne.capitalise(),
            id: this.cid + "formpanel",
            xtype: 'form',
            frame: false,
            border: false,
            region: 'center',
            height: 150,
            width: 150,
            bodyCls: "custom-body-form-panel",
            scrollable: 'y',
            defaults: {
                anchor: "0"
            },
            items: [{
                anchor: "0",
                layout: WindowExdMobileDEVICEV ? 'fit' : {
                    type: 'table',
                    columns: 2,
                    tableAttrs: {
                        style: {
                            width: '97%'
                        }
                    },
                    tdAttrs: {
                        valign: 'top'
                    }
                },
                frame: false,
                scrollable: WindowExdMobileDEVICEV,
                border: false,
                items: [{
                    layout: 'anchor',
                    frame: false,
                    border: false,
                    autoWidth: true,
                    scrollable: WindowExdMobileDEVICEV,
                    labelWidth: 80,
                    defaults: {
                        anchor: "0",
                        responsiveConfig: ResponsiveLabelAlignConfig
                    },
                    items: [{
                        id: this.cid + "nazwa",
                        name: "nazwa",
                        xtype: 'textfieldexd',
                        fieldLabel: Lang.nazwa,
                        allowBlank: false,
                        maxLength: 32,
                        blankText: Lang.pole_nie_moze_byc_puste
                    }, {
                        id: this.cid + "poziom",
                        name: "poziom",
                        xtype: 'numberfieldexd',
                        fieldLabel: Lang.poziom,
                        allowBlank: false,
                        minValue: 0,
                        maxValue: 10,
                        blankText: Lang.pole_nie_moze_byc_puste
                    }]
                }]
            }]
        };
        this.items = [{
            xtype: 'tabpanel',
            autoWidth: true,
            border: false,
            deferredRender: false,
            anchor: '0',
            activeTab: 0,
            scrollable: true,
            items: [formpanel, {
                title: Lang.custom_permissions.capitalise(),
                frame: false,
                border: false,
                anchor: "0",
                layout: {
                    type: 'vbox',
                    align: 'stretch'
                },
                height: 550,
                items: [{
                    xtype: 'grid',
                    tbar: [{
                        text: Lang.zaznacz_wszystko,
                        ui: 'btn-secondary-s',
                        listeners: {
                            scope: this,
                            click: function () {
                                var editgridpanelstore = Ext.getCmp(this.cid + "privilegesgrid").getStore();
                                for (var i = 0; i < editgridpanelstore.getCount(); i++) {
                                    var r = editgridpanelstore.getAt(i);
                                    if (r.get("id") != "access.view.stany_limit_only") {
                                        if (r.get("allowchange")) {
                                            r.set("value", true);
                                        }
                                    }
                                }
                                editgridpanelstore.commitChanges();
                            }
                        }
                    }, {
                        text: Lang.odznacz_wszystko,
                        ui: 'btn-secondary-s',
                        listeners: {
                            scope: this,
                            click: function () {
                                var editgridpanelstore = Ext.getCmp(this.cid + "privilegesgrid").getStore();
                                for (var i = 0; i < editgridpanelstore.getCount(); i++) {
                                    var r = editgridpanelstore.getAt(i);
                                    if (r.get("allowchange")) {
                                        r.set("value", false);
                                    }
                                }
                                editgridpanelstore.commitChanges();
                            }
                        }
                    }],
                    store: new Ext.data.Store({
                        autoLoad: false,
                        proxy: new Ext.data.MemoryProxy({}),
                        reader: new Ext.data.JsonReader({
                            id: "id",
                            rootProperty: ''
                        }, [{
                            name: 'id',
                            mapping: 'id'
                        }, {
                            name: 'nazwa',
                            mapping: 'nazwa'
                        }, {
                            name: 'value',
                            mapping: 'value'
                        }, {
                            name: 'allowchange',
                            mapping: 'allowchange'
                        }]),
                        sorters: [{
                            property: "nazwa",
                            direction: "ASC"
                        }]
                    }),
                    columns: [{
                        header: Lang.nazwa,
                        flex: 3,
                        sortable: true,
                        dataIndex: 'nazwa',
                        editable: false
                    }, {
                        xtype: 'checkcolumn',
                        header: Lang.przydzial,
                        dataIndex: 'value',
                        flex: 1,
                        listeners: {
                            scope: this,
                            checkchange: function () {
                                var store = Ext.getCmp(this.cid + "privilegesgrid").store;
                                store.commitChanges();
                            }
                        }
                    }],
                    clicksToEdit: 1,
                    frame: true,
                    border: false,
                    id: this.cid + "privilegesgrid",
                    bodyCls: "custom-body-form-panel",
                    flex: 1,
                    stateId: null,
                    scrollable: true,
                    stateful: false,
                    stripeRows: true,
                    enableHdMenu: false,
                    enableDragDrop: true,
                    ddGroup: this.cid + "groupColSelectedView",
                    ddText: '...',
                    selModel: {
                        selType: 'rowmodel',
                        mode: 'single'
                    },
                    listeners: {
                        scope: this
                    },
                    plugins: {
                        cellediting: {
                            clicksToEdit: 1
                        }
                    }
                }]
            }]
        }];
        this.buttons = [{
            xtype: 'tbfill'
        }, {
            id: this.cid + 'save',
            text: Lang.zapisz,
            ui: 'btn-primary-s',
            scope: this,
            handler: this.saveOp,
            disabled: !validPrivilegesOperatorComplex("access.manage.rolewlasne/update")
        }, {
            id: this.cid + 'cancel',
            text: Lang.anuluj,
            ui: 'btn-secondary-s',
            scope: this,
            handler: this.closeOp
        }];
        this.callParent(arguments);
    },
    showW: function (obiektid) {
        this.obiektid = obiektid;
        sendAjaxDataJsonRpcL("rest/ownoprole/getObjectForEdit", {
            id: this.obiektid
        }, this, function (data) {
            if (data.status) {
                this.obiekt = data.data;
                this.show();
                this.center();
                this.setKeyMap({
                    'ESC': {
                        scope: this,
                        handler: this.closeOp
                    }
                });
                var firma = null;
                if (this.obiekt && this.obiekt.firma) {
                    firma = this.obiekt.firma;
                }
                Ext.getCmp(this.cid + "nazwa").setValue(null);
                Ext.getCmp(this.cid + "nazwa").clearInvalid();
                Ext.getCmp(this.cid + "poziom").setValue(null);
                Ext.getCmp(this.cid + "poziom").clearInvalid();
                if (this.obiekt != null) {
                    Ext.getCmp(this.cid + "nazwa").setValue(this.obiekt.nazwa);
                    Ext.getCmp(this.cid + "poziom").setValue(this.obiekt.poziom);
                } else {
                    Ext.getCmp(this.cid + "poziom").setValue2(9);
                }
                var privileges = {};
                if (this.obiekt != null) {
                    privileges = this.obiekt.privileges;
                }
                var limPrivFirma = (Const.ENTERPRISEFLAG && ((this.obiekt && this.obiekt.firma) || AppFIRMACTX != null)) && !Const.CLOUDFLAG;
                sendAjaxDataJsonRpcL("rest/systemreq/getDefaultPriviligiesComplex", {
                    limitPrivilegesFirma: limPrivFirma
                }, this, function (defPrivData) {
                    if (defPrivData.status && defPrivData.data != null) {
                        var prvMapAll = defPrivData.data;
                        var prvMapLangAll = this.getValidPrivilegesOperatorComplexMapLang(defPrivData.data);
                        Ext.applyIf(privileges, prvMapAll);
                        var privilegesmaplist = [];
                        Ext.iterate(privileges, function (k, v, o) {
                            if (prvMapAll[k] !== undefined && validPrivilegesOperatorComplex(k)) {
                                if (k.indexOf("limit_only") > -1 && Const.ENTERPRISEFLAG && ((this.obiekt && !this.obiekt.firma) || (!this.obiekt && AppFIRMACTX == null)))
                                    return;
                                if (k.indexOf("dziennik") > -1 && Const.ENTERPRISEFLAG && (AppFIRMACTX != null || (this.obiekt && this.obiekt.firma)))
                                    return;
                                if (k.indexOf("plyn") > -1 && Const.ENTERPRISEFLAG && (AppFIRMACTX != null || (this.obiekt && this.obiekt.firma)))
                                    return;
                                privilegesmaplist.push({
                                    id: k,
                                    nazwa: prvMapLangAll[k] == null ? k : prvMapLangAll[k],
                                    value: privileges[k],
                                    allowchange: true
                                });
                            }
                        }, this);
                        var privilegesgrid = Ext.getCmp(this.cid + "privilegesgrid");
                        privilegesgrid.store.loadData(privilegesmaplist);
                    } else {
                        Ext.MessageBox.alert(Lang.error, zbdata.error);
                    }
                });
                var title = Lang.role_wlasne.capitalise();
                if (AppFIRMACTX != null)
                    title += " (" + AppFIRMACTX.nazwa + ")";
                this.setTitle(title);
            } else {
                Ext.MessageBox.alert(Lang.error, data.error);
            }
        });
    },
    saveOp: function () {
        var canWrite = false;
        if (Ext.getCmp(this.cid + "nazwa").isValid()) {
            if (Ext.getCmp(this.cid + "poziom").isValid()) {
                canWrite = true;
            }
        }
        if (canWrite) {
            this.performSave()
        } else {
            Ext.MessageBox.alert(Lang.error, Lang.dane_niepoprawne);
        }
    },
    getValidPrivilegesOperatorComplexMapLang: function (privmap) {
        var privlang = {};
        Ext.iterate(privmap, function (k, v, o) {
            var langkey = k.replace(/\./g, "_");
            if (Const.ENABLEKELLER && (langkey === "access_view_pojazdy" || langkey === "access_manage_pojazdy")) {
                langkey += "_wlasny";
            }
            privlang[k] = Lang[langkey];
        });
        return privlang;
    },
    performSave: function () {
        var privilegesmap = {};
        var privilegesgrid = Ext.getCmp(this.cid + "privilegesgrid");
        var sprivilegesgrid = privilegesgrid.store;
        for (var i = 0; i < sprivilegesgrid.getCount(); i++) {
            var row = sprivilegesgrid.getAt(i);
            if (validPrivilegesOperatorComplex(row.id)) {
                privilegesmap[row.id] = row.get("value");
            } else {
                privilegesmap[row.id] = this.obiekt != null ? this.obiekt.privileges[row.id] : false;
            }
        }
        sendAjaxDataJsonRpcL("rest/ownoprole/saveObject", {
            id: this.obiektid,
            nazwa: Ext.getCmp(this.cid + "nazwa").getValue(),
            poziom: Ext.getCmp(this.cid + "poziom").getValue(),
            privileges: privilegesmap
        }, this, function (data) {
            if (data.status) {
                data = data.data;
                this.obiektid = data.id;
                this.closeOp();
            } else {
                Ext.MessageBox.alert(Lang.error, data.error);

            }
        });
    },
    closeOp: function () {
        this.fireEvent("wclose");
        this.close();
    }
});
